module.exports = __webpack_public_path__ + "static/media/ball_ended_eye_link_horn_holder.246e52ef.webp";